const QUESTIONS = [
  {
    question: "What is Uptime Monitor and how does it work?",
    answer:
      "Uptime Monitor checks the accessibility and responsiveness of your websites and servers from multiple locations worldwide.",
  },
  {
    question: "Do you offer a free trial?",
    answer:
      "Yes, all plans come with a free trial. During this period, you'll have full access to all features of your selected plan with no commitment. This allows you to thoroughly test our service before being charged. No credit card is required to start your trial.",
  },
  {
    question: "What is Multi-Region Monitoring?",
    answer:
      "Multi-Region Monitoring means that we check your website's uptime from multiple locations around the world. This helps in accurate detection of downtime and reduces the chances of false alarms.",
  },
  {
    question: "Why should I monitor SSL certificate expiration with Uptime Monitor?",
    answer:
      "Uptime Monitor sends you warnings if your certificate is about to expire in 30, 14, 7, and 1 day. This feature helps to prevent the disruption of services and security issues related to expired certificates.",
  },
  {
    question: "Can I customize the HTTP(S) monitoring requests with Uptime Monitor?",
    answer:
      "Yes, with Uptime Monitor you can use custom HTTP headers or payloads in the monitoring request. Additionally, you can check response headers and payload.",
  },
  {
    question: "What does the status page feature offer?",
    answer:
      "Our service includes a status page that allows you to display the current status of your websites and servers to your users. You can easily set up a custom domain name with HTTPS encryption, promoting transparency with your users.",
  },
  {
    question: "What are the different types of notifications provided by Uptime Monitor?",
    answer:
      "Uptime Monitor can alert you via various channels when your websites or servers are down or experiencing issues. These notifications can be sent via email, Slack, Discord, webhook, PagerDuty, and more.",
  },
  {
    question: "How do email notification limits work?",
    answer:
      "Each plan includes a daily email allowance that matches the plan's monitor count (e.g., the 50 monitor plan includes 50 emails per day). Uptime Monitor partners with premium service providers to ensure the most reliable alert delivery. If you need more daily emails, additional credit packages (1,000 / 3,000 / 10,000) can be purchased from the Settings page. Other notification channels like webhooks, Slack, Discord, and PagerDuty have no sending limits.",
  },
  {
    question: "How does the SSL certificate expiration check function?",
    answer:
      'To utilize the SSL certificate expiration check, you simply have to check the "Warn me about SSL certificate expiration" box in the monitor settings. Upon activation, Uptime Monitor performs a minimum of one check daily. If the certificate is nearing expiration, you will receive alert notifications on the day of expiration as well as 1, 7, 14, and 30 days prior. These notifications will be sent to the same contacts you\'ve designated in your monitor settings, providing ample time to renew your certificate and prevent service disruption.',
  },
  {
    question: "Which IP addresses does Uptime Monitor use to check websites?",
    answer:
      "Uptime Monitor uses a set of specific IP addresses to monitor websites. You can access an updated list of these IPs by visiting https://uptime-monitor.io/web_api/checker_ip_addresses.",
  },
  {
    question: "Is there a CLI or API for managing monitors?",
    answer:
      "Yes. Uptime Monitor provides a full REST API and an official CLI tool. The CLI lets you manage monitors, contacts, incidents, and status pages directly from your terminal. We also offer an official Terraform provider for infrastructure-as-code workflows. See our API documentation and Terraform provider docs for details.",
  },
];

export default function Faq() {
  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>

      {QUESTIONS.map((q, i) => (
        <div key={`qa-${i}`} className="mt-8">
          <h3 className="text-lg font-semibold mb-2">{q.question}</h3>
          <p>{q.answer}</p>
        </div>
      ))}
    </div>
  );
}
